/* eslint-disable global-require */
if (process.env.ENVIRONMENT === 'production') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}
